import {createActions} from 'redux-actions';

export default createActions({
    START_PROCESS: undefined,
    FINISH_PROCESS: undefined,
    SHOW: undefined,
    HIDE: undefined,
})
